ObjectUtils.define('UIMembershipPlansController', UIController, {

  didControlChangeValue: function didControlChangeValue(container, target, data) {
    if (data.name === 'planPeriod') {
      DOM.addClassIf(container, 'selectedPeriod-1', data.value === '1');
      DOM.addClassIf(container, 'selectedPeriod-12', data.value === '12');
    }

    return EventDelegater.FORWARD;
  },

});
